import {useQuery} from '@apollo/client';
import {PHARMACY_OPTIONS} from "../pharmacyTypeDefs";

export const useQueryPharmacyOptions = (options?: any): any => (
  useQuery(PHARMACY_OPTIONS, options)
);
